import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { RouteErrorBoundary } from "@/components/common/RouteErrorBoundary";

import { PartnerShell } from "./PartnerShell";

/**
 * Layout route for an authenticated partner portal. The shell mounts ONCE and
 * only the <Outlet/> swaps; a render crash in a page leaves the shell usable.
 */
export const PartnerLayout = () => {
  const { pathname } = useLocation();
  return (
    <PartnerShell>
      <RouteErrorBoundary resetKey={pathname}>
        <Suspense
          fallback={
            <div className="flex min-h-[40vh] flex-1 items-center justify-center">
              <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" aria-label="Loading" />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </RouteErrorBoundary>
    </PartnerShell>
  );
};

export default PartnerLayout;
